import axios from "axios";
import Utils from "../utils/utils";
import AppLib from "./AppLib";
const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
let token = Utils.getToken();

const Students = {
  STUDENT_CRITERIA: {
    1: "Attendance",
    2: "Communication Skills",
    3: "Class Presence",
    4: "Technical Skills",
    5: "Assignment Submission",
    6: "Collaboration & Teamwork",
    7: "Concept Understanding",
    8: "Presentation Skills",
    9: "Project Participation",
  },
  getStudents: async function (query) {
    if (!token) token = AppLib.token; // Ensure token is set
    try {
      const response = await axios.get(`${SERVER_URL}/students`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: query,
      });

      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "An error occurred while fetching students",
      };
    }
  },
  addStudentProgress: async function (formData) {
    if (!token) token = AppLib.token; // Ensure token is set
    try {
      const response = await axios.post(
        `${SERVER_URL}/students/progress`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "An error occurred while assessing student",
      };
    }
  },
  getStudentProgressData: async function (query) {
    if (!token) token = AppLib.token; // Ensure token is set
    try {
      const response = await axios.get(`${SERVER_URL}/students/progress`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: query,
      });

      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "An error occurred while fetching students progress report",
      };
    }
  },
};

export default Students;
